export class ThemeConstants {
    static readonly default: string = "defaultTheme";
    static readonly pakFoods: string = "pakFoodsTheme";
}
